/* eslint-disable import/prefer-default-export */
import { graphql } from 'graphql-schema';

export const TEAM_SCHEDULE_HASURA_IMPL = graphql(`
  query TeamSchedule($teamId: uuid!) {
    teams_by_pk(_id: $teamId) {
      leagueByLeague {
        _id
        games(
          where: { teams: { team: { _eq: $teamId } } }
          order_by: { start_time: asc }
          limit: 1
        ) {
          _id
          start_time
          end_time
        }
      }
    }
  }
`);
